import React, { useEffect, useState } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { RadioButton } from "primereact/radiobutton";
import { InputMask } from "primereact/inputmask";
import { InputText } from "primereact/inputtext";

interface Props {
  show: any;
  onHide: any;
  handleFinalizar: any;
  controller: any;
}

export default function ModalContribuirComoEvento({
  show,
  onHide,
  handleFinalizar,
  controller,
}: Props) {
  const [enableFieldCnpj, setEnableFieldCnpj] = useState([true, false]);
  const [enableFieldCnpjAvulso, setEnableFieldCnpjAvulso] = useState(false);
  const membro = JSON.parse(sessionStorage.getItem("membro") || "{}");

  useEffect(() => {
    if (show) {
      const flags = [true, false];
      controller.empresaList.forEach(() => {
        flags.push(false);
      });
      setEnableFieldCnpj(flags);
      setEnableFieldCnpjAvulso(false);
    }
  }, [show]);

  const dialogStyle = {
    width: "500px",
  };

  const setarRadioButtons = (index: any) => {
    setEnableFieldCnpjAvulso(enableFieldCnpj.length - 1 == index);
    const flags = enableFieldCnpj;

    enableFieldCnpj.forEach((element) => {
      flags[flags.indexOf(element)] = false;
    });
    flags[index] = true;
    setEnableFieldCnpj(flags);
  };

  const [cnpjAvulso, setCnpjAvulso] = useState("");

  const formatarCnpj = (valor: string) => {
    const v = valor.replace(/[^A-Z0-9]/g, "");

    if (v.length <= 2) return v;
    if (v.length <= 5) return v.replace(/^(.{2})(.*)/, "$1.$2");
    if (v.length <= 8) return v.replace(/^(.{2})(.{3})(.*)/, "$1.$2.$3");
    if (v.length <= 12)
      return v.replace(/^(.{2})(.{3})(.{3})(.*)/, "$1.$2.$3/$4");

    return v.replace(/^(.{2})(.{3})(.{3})(.{4})(.{0,2}).*/, "$1.$2.$3/$4-$5");
  };

  return (
    <>
      <Dialog
        onHide={() => onHide()}
        visible={show}
        style={dialogStyle}
        draggable={false}
        className="contribuir-como-dialog"
        header={
          <div className="contribuir-como-header">
            <div className="contribuir-como-header__icon">
              <i className="pi pi-user-plus" />
            </div>
            <div>
              <h3 className="contribuir-como-header__title">Contribuir como</h3>
              <p className="contribuir-como-header__subtitle">
                Selecione como deseja contribuir neste evento
              </p>
            </div>
          </div>
        }
        footer={
          <div className="contribuir-como-footer">
            <Button
              label="Cancelar"
              type="button"
              icon="pi pi-times"
              onClick={() => onHide()}
              className="contribuir-como-footer__cancel p-button-text"
            />
            <Button
              icon="pi pi-check"
              label="Realizar contribuição"
              className="contribuir-como-footer__submit"
              onClick={() => {
                handleFinalizar();
              }}
            />
          </div>
        }
      >
        <div className="contribuir-como-body">
          <div className="contribuir-como-section">
            <div className="contribuir-como-section__label">
              <i className="pi pi-user" />
              Pessoa Física
            </div>
            <div key={0} className="contribuir-como-row">
              <RadioButton
                value={controller.noUsuarioCadastro}
                onChange={(e) => {
                  setarRadioButtons(0);
                  controller.setNoUsuarioCadastro(controller.cpf);
                }}
                checked={enableFieldCnpj[0]}
              />
              <InputMask
                mask="999.999.999-99"
                value={membro.cpf ? membro.cpf : controller.cpf}
                disabled={true}
              />
            </div>
          </div>

          {!membro.cpf && (
            <div className="contribuir-como-section">
              <div className="contribuir-como-section__label">
                <i className="pi pi-building" />
                Pessoa Jurídica
              </div>
              {controller.empresaList.map((m: any, index: any) => (
                <div key={index} className="contribuir-como-row">
                  <RadioButton
                    value={controller.noUsuarioCadastro}
                    onChange={(e) => {
                      setarRadioButtons(index + 1);
                      controller.setNoUsuarioCadastro(m.cnpj);
                    }}
                    checked={enableFieldCnpj[index + 1]}
                  />
                  <InputText
                    value={formatarCnpj(m.cnpj || "")}
                    disabled={true}
                  />
                </div>
              ))}

              <div
                key={enableFieldCnpj.length - 1}
                className="contribuir-como-row"
              >
                <RadioButton
                  value={controller.noUsuarioCadastro}
                  onChange={(e) => {
                    setarRadioButtons(enableFieldCnpj.length - 1);
                  }}
                  checked={enableFieldCnpjAvulso}
                />
                <InputText
                  value={formatarCnpj(cnpjAvulso)}
                  disabled={!enableFieldCnpjAvulso}
                  onChange={(e) => {
                    const valorLimpo = e.target.value
                      .toUpperCase()
                      .replace(/[^A-Z0-9]/g, "");

                    if (valorLimpo.length <= 14) {
                      setCnpjAvulso(valorLimpo);
                      controller.setNoUsuarioCadastro(valorLimpo);
                    }
                  }}
                  placeholder="Informe o CNPJ"
                />
              </div>
            </div>
          )}
        </div>
      </Dialog>
    </>
  );
}
